<body class="d-flex flex-column h-100">

	<!-- Begin page content -->
	<main class="flex-shrink-0">
		<div class="container">
			<div class="row mt-5" *ngFor="let item of leadershipItem">
				<div class="col-lg-4">
					<div class="card">
						<img src="{{item.image}}" class="card-img-top" alt="portrait" width="100%">
						<div class="card-body">
							<h5 class="card-title">{{item.name}}</h5>
							<p class="card-text">{{item.rank}}</p>
						</div>
					</div>
				</div>
				<div class="col-lg-8">
					<section class="champs-content" id="champs">
						<div class="card mb-3">
							<div class=" row g-0">
								<div class="col-lg-12">
									<div class="card-body info-body">
										<div class="col-lg-12">
											<h5 translate class="card-title">guide-item.bio</h5>
										</div>
										<div class="col-lg-12">
											<div class="row">
												<div class="col-lg-6">
													<span translate class="sec">guide-item.dob</span> <br>
													<span class="rt">{{item.bitrhday}}</span>
												</div>
												<div class="col-lg-6">
													<span translate class="sec">guide-item.rank</span> <br>
													<span class="rt">{{item.degree}}</span>
												</div>
											</div>
											<br>
											<div class="row">
												<div class="col-lg-6">
													<span translate class="sec">guide-item.place_of_residence</span> <br>
													<span class="rt">{{item.address}}</span>
												</div>
												<div class="col-lg-6">
													<span translate class="sec">guide-item.dot</span> <br>
													<span class="rt">{{item.assigned_degree}}</span>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>

					<section class="dost">
						<span>
							{{item.description}}
						</span>
					</section>
				</div>
			</div>
		</div>
	</main>
</body>
